export const WINDOW_RESIZE = 'WINDOW_RESIZE';
